import { QueryOptions } from "../components/Common/useQuery";
import useUserQuery from "../components/Common/useUserQuery";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";
import DriverDto from "../components/Common/dtos/DriverDto";

const useGetDrivers = (options?: QueryOptions<DriverDto[]>) => {
  const business = useSelectedBusiness();
  return useUserQuery<DriverDto[]>({ path: `/api/businesses/${business.id}/drivers` }, options);
}

export default useGetDrivers;
